import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const useStyles = makeStyles(theme => ({
  field: { marginBottom: theme.spacing(2.5) },
  label: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.45, marginBottom: theme.spacing(0.5) },
  description: { fontSize: '0.75rem', lineHeight: 1.5, color: theme.palette.text.secondary, marginBottom: theme.spacing(0.5) },
}));

/** Structured values stay editable; invalid JSON never reaches the configuration. */
const CompactJsonInput = ({ title, description, value, onChange, disabled, expectedType }) => {
  const classes = useStyles();
  const t = useLocalizedMessage();
  const serialized = JSON.stringify(value === undefined ? null : value, null, 2);
  const [draft, setDraft] = useState(serialized);
  const [error, setError] = useState(false);
  useEffect(() => { setDraft(serialized); setError(false); }, [serialized]);
  return (
    <Box className={classes.field}>
      <Typography className={classes.label}>{title}</Typography>
      {description && <Typography className={classes.description}>{description}</Typography>}
      <TextField
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        size="small"
        disabled={disabled}
        value={draft}
        error={error}
        helperText={t(error ? 'searchInterface.inspector.invalidJson' : 'searchInterface.inspector.jsonHint')}
        inputProps={{ 'aria-label': title, spellCheck: false, style: { fontFamily: 'monospace', fontSize: 12 } }}
        onChange={(event) => {
          setDraft(event.target.value);
          try {
            const parsed = JSON.parse(event.target.value);
            if (expectedType === 'array' && !Array.isArray(parsed)) throw new Error('array');
            if (expectedType === 'object' && (parsed === null || Array.isArray(parsed) || typeof parsed !== 'object')) throw new Error('object');
            setError(false);
            onChange(parsed);
          } catch (_) { setError(true); }
        }}
      />
    </Box>
  );
};

export default CompactJsonInput;
